<template>
  <v-card class="restaurant-card">
    <v-img height="200px" v-bind:src="restaurant.pictures[0]"></v-img>
    <v-card-title
      id="card-title" align="left">
      {{ restaurant.name }}
    </v-card-title>
    <v-rating
      class="ml-4"
      :value="restaurant.rating"
      color="warning"
      dense
      background-color="warning lighten-1"
      half-increments
      readonly
      size="14"
    ></v-rating>
    <v-card-actions>
      <v-btn
        text
        outlined
        background-colorcolor="accent"
      >
        <router-link
          style="text-decoration: none; color: inherit;"
          :to="{
          name: 'Restaurant',
          params: {
            userToken: userToken,
            restaurant: restaurant,
            restaurants : restaurants
            }
          }"
        >More info </router-link>
      </v-btn>

      <ModalFavoris
        v-bind:user-token="userToken"
        v-bind:restaurant="restaurant"
        v-bind:modal-visible="modalVisible"
        v-bind:logged="logged"
      ></ModalFavoris>

      <ModalVisit
        v-bind:user-token="userToken"
        v-bind:modal-visible="modalVisible"
        v-bind:restaurant-name="restaurant.name"
        v-bind:restaurant-id="restaurant.id"
        v-bind:logged="logged"
      />
    </v-card-actions>

  </v-card>
</template>

<script>
import ModalVisit from "../Visits/ModalVisit";
import ModalFavoris from "../Favorites/ModalFavoris";
import Api from "../../services/api";
export default {
  name: "restaurant-card",
  components: {
    ModalVisit,
    ModalFavoris,
  },
  props: ['restaurants','restaurant','userToken'],
  data: () => ({
    modalVisible : false,
    logged : false,

  }),
  async created () {
    this.api = new Api()
    await this.checkUserToken()
  },

  methods: {
    async checkUserToken() {
      let token = this.loadToken()
      let userTokenInfo = await this.api.getToken(token);
      if (userTokenInfo === "") {
        this.logged = false;
      } else {
        this.logged = true;
      }
    },

    loadToken() {
      let token = this.$cookies.get('user_token');
      if (token !== null) {
        return token
      }
    },
  }
}
</script>

<style scoped>
.restaurant-card {
  position: relative;
}
#card-title {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}
</style>
